import { appleDevice } from '../constants/appleDevice'

export function getControlPlatformHotkey(suffix: string): string {
  return (appleDevice ? 'Cmd' : 'Ctrl') + suffix
}
